/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pen': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g clip-path="url(#svgicon-pen-a)"><path pid="0" d="M19.268 2.5L17.5.732A2.494 2.494 0 0 0 15.732 0c-.64 0-1.279.244-1.767.732L3.232 11.465c-.488.488-1.981 2.377-1.982 3.016L0 20l5.518-1.25s2.529-1.494 3.017-1.983L19.268 6.035a2.5 2.5 0 0 0 0-3.535zM1.657 18.343l.812-3.586c.011-.051.02-.104.025-.155.002-.007.009-.018.012-.026l2.826 2.828-.283.17-3.392.77zm5.997-2.462c-.142.135-.631.466-1.23.846L3.187 13.49c.332-.456.702-.913.93-1.14l8.081-8.081 3.535 3.535-8.078 8.078zm10.73-10.73L16.616 6.92l-3.535-3.535 1.768-1.768c.236-.236.55-.366.883-.366.334 0 .649.13.885.366l1.767 1.768c.237.236.366.55.366.884 0 .333-.13.648-.366.883z" _fill="#766E6A"/></g><defs><clipPath id="svgicon-pen-a"><path pid="1" _fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs>'
  }
})
